import { get } from 'lodash';
import { ServiceCode } from '../enums/serviceCode';
import { SupervisionValidationTypes } from '../enums/supervisionValidationTypes';

const supervisionValidationTypes = {
    [ServiceCode.TPO]: {
        draft: {
            1: SupervisionValidationTypes.tpoV1EditSupervisionDraft,
        },
        final: {
            1: SupervisionValidationTypes.tpoV1EditSupervision,
        },
    },
    [ServiceCode.TCOR]: {
        draft: {
            1: SupervisionValidationTypes.tcorV1EditSupervisionDraft,
        },
        final: {
            1: SupervisionValidationTypes.tcorV1EditSupervision,
        },
    },
    [ServiceCode.TCOH]: {
        draft: {
            1: SupervisionValidationTypes.tcohV1EditSupervisionDraft,
            2: SupervisionValidationTypes.tcohV2EditSupervisionDraft,
        },
        final: {
            1: SupervisionValidationTypes.tcohV1EditSupervision,
            2: SupervisionValidationTypes.tcohV2EditSupervision,
        },
    },
    [ServiceCode.TIECG]: {
        draft: {
            1: SupervisionValidationTypes.tiecgV1EditSupervisionDraft,
        },
        final: {
            1: SupervisionValidationTypes.tiecgV1EditSupervision,
        },
    },
    [ServiceCode.TFO]: {
        draft: {
            1: SupervisionValidationTypes.tfoV1EditSupervisionDraft,
        },
        final: {
            1: SupervisionValidationTypes.tfoV1EditSupervision,
        },
    },
    [ServiceCode.PILOT]: {
        draft: {
            1: SupervisionValidationTypes.pilotExaminationV1EditSupervisionDraft,
        },
        final: {
            1: SupervisionValidationTypes.pilotExaminationV1EditSupervision,
        },
    },
};

export function getSupervisionValidationType(
    serviceCode: ServiceCode,
    version: number,
    draftOrFinal: 'draft' | 'final'
) {
    return get(supervisionValidationTypes, [serviceCode, draftOrFinal, version]);
}
